import { useEffect, useState } from 'react';

import { authService, CurrentUser } from '../../services/auth';
import { AvailablePlatform, usersService } from '../../services/users';
import { EmptyState } from './components/EmptyState';
import { PlatformGrid } from './components/PlatformGrid';

export const Dashboard = (): JSX.Element => {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [availablePlatforms, setAvailablePlatforms] = useState<AvailablePlatform[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      try {
        setLoading(true);
        const user = authService.getUserInfo();
        setCurrentUser(user);

        const platforms = await usersService.getAvailablePlatforms();
        setAvailablePlatforms(platforms);
      } catch (error) {
        console.error('Failed to load available platforms:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();

    const updateUser = (): void => {
      const updatedUser = authService.getUserInfo();
      setCurrentUser(updatedUser);
      loadData();
    };

    authService.registerSubscriber(updateUser);

    return () => {
      authService.unregisterSubscriber(updateUser);
    };
  }, []);

  return (
    <div className="p-4 max-w-[1400px] mx-auto">
      <div className="mb-8">
        <h1 className="mb-2 text-[clamp(24px,5vw,32px)] font-bold text-gray-900">
          Welcome, {currentUser?.firstName} {currentUser?.lastName}
        </h1>
        <p className="text-[clamp(14px,3vw,16px)] text-gray-500 font-normal">Select a platform to access</p>
      </div>

      {loading ? (
        <PlatformGrid platforms={[]} loading />
      ) : availablePlatforms.length > 0 ? (
        <PlatformGrid platforms={availablePlatforms} />
      ) : (
        <EmptyState />
      )}
    </div>
  );
};
